<template>
  <div>
    <vx-card v-if="orgData && orgData._id" class="org-card">
      <vs-tabs 
        v-model="activeTab" 
        :position="isSmallerScreen ? 'top' : 'left'" 
        class="tabs-shadow-none" 
        id="profile-tabs"
        :key="isSmallerScreen"
      >
        <vs-tab icon-pack="feather" icon="icon-user" :label="!isSmallerScreen ? 'Account' : ''">
          <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
            <org-settings-account />
          </div>
        </vs-tab>

        <vs-tab icon-pack="feather" icon="icon-shield" :label="!isSmallerScreen ? 'Administration' : ''">
          <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
            <org-settings-admins />
          </div>
        </vs-tab>
        
        <vs-tab icon-pack="feather" icon="icon-box" :label="!isSmallerScreen ? 'Configuration' : ''">
          <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
            <org-settings-config />
          </div>
        </vs-tab>
        
        <vs-tab icon-pack="feather" icon="icon-trending-up" :label="!isSmallerScreen ? 'Evaluation' : ''">
          <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
            <org-settings-evaluate 
              ref="evaluatePage" 
              @dirty-state-changed="handleDirtyStateChanged"
              @proceed-to-tab="handleProceedToTab"
            />
          </div>
        </vs-tab>

        <!-- <vs-tab icon-pack="feather" icon="icon-list" :label="!isSmallerScreen ? 'Metrics Library' : ''">
          <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
            <org-settings-criteria-library 
              ref="criteriaLibraryPage" 
              @dirty-state-changed="handleCriteriaDirtyStateChanged"
              @proceed-to-tab="handleProceedToTab"
            />
          </div>
        </vs-tab>

        <vs-tab icon-pack="feather" icon="icon-dollar-sign" :label="!isSmallerScreen ? 'Compensation' : ''">
          <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
            <org-settings-compensation />
          </div>
        </vs-tab> -->
        
        <vs-tab icon-pack="feather" icon="icon-credit-card" :label="!isSmallerScreen ? 'Subscription' : ''">
          <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
            <org-subscripiton />
          </div>
        </vs-tab>
      </vs-tabs>
    </vx-card>
  </div>
</template>

<script>
import OrgSettingsAccount from "./OrgSettingsAccount.vue";
import OrgSettingsPlatformPreferences from "./OrgSettingsPlatformPreferences.vue";
import OrgSettingsApps from "./OrgSettingsApps.vue";
import OrgSettingsResumeSettings from "./OrgSettingsResumeSettings.vue";
import OrgSettingsAdmins from "./OrgSettingsAdmins.vue";
import OrgSettingsHelp from "./OrgSettingsHelp.vue";
import OrgSettingsDeveloper from "./OrgSettingsDeveloper.vue";
import OrgSettingsFunds from "./OrgSettingsFunds.vue";
import OrgSettingsConfig from "./OrgSettingsConfig.vue";
import OrgSettingsEvaluate from "./OrgSettingsEvaluate.vue";
import OrgSettingsCriteriaLibrary from "./OrgSettingsCriteriaLibrary.vue"; // Imported NEW file
import OrgSettingsCompensation from "./OrgSettingsCompensation.vue"; 
import OrgSubscripiton from "./Subscription.vue";

export default {
  components: {
    OrgSettingsAccount,
    OrgSettingsPlatformPreferences,
    OrgSettingsApps,
    OrgSettingsResumeSettings,
    OrgSettingsAdmins,
    OrgSettingsHelp,
    OrgSettingsDeveloper,
    OrgSettingsFunds,
    OrgSettingsConfig,
    OrgSettingsEvaluate,
    OrgSettingsCriteriaLibrary, // Registered NEW component
    OrgSettingsCompensation, 
    OrgSubscripiton
  },
  data() {
    return {
      activeTab: 0,
      isEvaluateDirty: false,
      isCriteriaDirty: false, // NEW: Track dirty state for criteria tab
      isSwitchingTabProgrammatically: false
    };
  },
  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
    userData() {
      return this.$store.state.users.data;
    },
    orgData() {
      return this.$store.state.organization.orgData;
    },
    isSubAdmin() {
      if (!(this.orgData && this.orgData._id)) return true;
      else if (
        this.orgData.subAdmins &&
        this.orgData.subAdmins.findIndex(
          (sa) => sa.email === this.userData.email
        ) != -1
      )
        return true;
      return false;
    },
  },
  watch: {
    activeTab(newVal, oldVal) {
      if (this.isSwitchingTabProgrammatically) return;

      // Handle Unsaved changes for Evaluation Tab (Index 3)
      if (oldVal === 3 && this.isEvaluateDirty) {
        this.isSwitchingTabProgrammatically = true;
        this.activeTab = oldVal;
        
        this.$nextTick(() => {
          this.isSwitchingTabProgrammatically = false;
        });

        if (this.$refs.evaluatePage) {
          this.$refs.evaluatePage.triggerUnsavedPopup(newVal);
        }
        return;
      }

      // Handle Unsaved changes for Metrics Library Tab (Index 4)
      if (oldVal === 4 && this.isCriteriaDirty) {
        this.isSwitchingTabProgrammatically = true;
        this.activeTab = oldVal;
        
        this.$nextTick(() => {
          this.isSwitchingTabProgrammatically = false;
        });

        if (this.$refs.criteriaLibraryPage) {
          this.$refs.criteriaLibraryPage.triggerUnsavedPopup(newVal);
        }
        return;
      }
    },
    orgData(newVal) {
      if (newVal) {
        // this.checkIfSubAdmin();
      }
    },
  },
  methods: {
    handleDirtyStateChanged(isDirty) {
      this.isEvaluateDirty = isDirty;
    },
    // NEW: Handler for criteria tab dirty state
    handleCriteriaDirtyStateChanged(isDirty) {
      this.isCriteriaDirty = isDirty;
    },
    handleProceedToTab(targetTabIndex) {
      this.isSwitchingTabProgrammatically = true;
      this.activeTab = targetTabIndex;
      this.$nextTick(() => {
        this.isSwitchingTabProgrammatically = false;
      });
    },
    checkIfSubAdmin() {
      const orgObj = {
        email: this.userData.email,
        organizationId: this.orgData._id,
      };
      this.$store
        .dispatch("organization/fetchSubAdminByEmailOrgId", orgObj)
        .then((res) => {
          if (res.data.total > 0) {
            this.isSubAdmin.value = true;
          } else {
            this.isSubAdmin.value = false;
          }
          this.isSubAdmin.checked = true;
          this.$forceUpdate();
        });
    },
  },
};
</script>

<style scoped lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>